/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import { get, isEmpty, sortBy } from "lodash";
import DetailCommunity from "./DetailCommunity";
import useForm from "../../hooks/useForm";
import { useSelector } from "react-redux";
import { permissionCheck } from "../../utils/permission";
import { useHistory } from "react-router-dom";
import { deleteCommunity, getCommunityList } from "../../apis/community/community";
import { CardList } from "../../components/List";
import Icon from "../../components/Icon";
import BoardIcon from "../../assets/images/icon/board-writing.svg";
import SecretBoardIcon from "../../assets/images/icon/board-secret.svg";
import Button from "../../components/Button";
import { preventEvent } from "../../utils/element";
import systemAlert from "../../utils/systemAlert";
import { isManagingType } from "../../utils/auth";

const CommunityList = () => {
  const history = useHistory()
  const { permissions, employee } = useSelector((store) => ({
    permissions: store.Profile.permissions,
    employee: store.Profile.employee,
  }));

  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedCommunity, setSelectedCommunity] = useState(null);
  const [targetPermission, setTargetPermission] = useState(null)

  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (isEmpty(targetPermission) || isEmpty(employee)) {
      setFields([])
      return
    }

    setFields([
    {
      onValue: (data, field, datas) => {
      
        const isAdmin = datas.employees.find(e => e.idx === employee.idx && e.level >= 9)
        const accessManager = isManagingType() ? (datas.isManager === 1 ? true : false) : true
        /*
        const isCeo = targetPermission.level >= 9 && !isManagingType()
        */
        return (
          <div className="list-item" onClick={() => {
            if (!accessManager) {
              systemAlert('게시글 접근 권한이 없습니다.')
            } else {
              history.push(`/community/${datas.idx}`);
            }
          }}>
            <span className="circle-icon">
              <Icon src={datas.isSecret ? SecretBoardIcon : BoardIcon}> </Icon>
            </span>
            <p className="title"> {datas.title} {datas.isAnonymous && " (익명)"}</p>
            <p className="content"> {datas.description} </p>
            <div className="date-profile" >
              { targetPermission.level >= 2 || !isEmpty(isAdmin) ? 
                (
                  <>
                    <Button color="text" onClick={((e) => {
                      preventEvent(e);
                      openDetail(datas)
                    })}>수정</Button>
                    <Button color="text" onClick={((e) => {
                      preventEvent(e);
                      systemAlert(`"${datas.title}" 커뮤니티를 삭제하시겠습니까?\n삭제시 해당 커뮤니티 관련 모든 게시글도 삭제됩니다.`, {
      
                        buttons: [
                          {
                            color: 'text',
                            label: '취소'
                          },
                          {
                            label: '삭제',
                            onClick: () => {
                              systemAlert('삭제되었습니다.')
                              deleteCommunity(datas.idx)
                                .then(() => {
                                  if (submit) {
                                    submit()
                                  }
                                })
                            }
                          }
                        ]
                      })
                    })}>삭제</Button>
                  </>
                ) 
                : (
                  <>
                    <Button color="text" style={{opacity: 0.5}} onClick={((e) => {
                      preventEvent(e);
                      openDetail(datas)
                    })}>수정</Button>
                    <Button color="text" style={{opacity: 0.5}} onClick={((e) => {
                      preventEvent(e);
                    })}>삭제</Button>
                  </>
                )
              }

            </div>
          </div>
        );
      },
    },
  ]);
  }, [employee, targetPermission]);


  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'COMMUNITY')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "COMMUNITY")
      }
    }
  }, [permissions])

  const {
    form,
    setSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
  } = useForm(
    {
      searchType: 'name',
      searchText: '',
      order: [
        {
          idx: 'desc'
        }
      ],
      page: 0,
      limit: 10
    },
  )

  useEffect(() => {
    if (targetPermission) {
      submit(form);
      setSubmit(submit)
    }
  }, [targetPermission]);

  const submit = (params) => {

    getCommunityList()
    .then((res) => {
      if (targetPermission.level >= 9) {
        if (isManagingType()) { // 세무담당자
          //setList(sortBy(get(res, "data.communities").filter(e => e.isManager === 1), ['isSecret', 'idx']).reverse());
          setList(sortBy(get(res, "data.communities"), ['isSecret', 'idx']).reverse());
        } else { // ceo
          //setList(sortBy(get(res, "data.communities").filter(e => e.isSecret === 0 || e.employees.find(e => e.idx === employee.idx)), ['isSecret', 'idx']).reverse());
          setList(sortBy(get(res, "data.communities"), ['isSecret', 'idx']).reverse());
        }
      } else {
        setList(sortBy(get(res, "data.communities"), ['isSecret', 'idx']).reverse());
      }
    })
    .catch((err) => {
      console.error(err.response);
    })
    .finally(() => {
      setIsLoading(false)
    });

  };

  const headerButtons = [
    {
      isHide: !(targetPermission && targetPermission.level > 1),
      label: "게시판 생성",
      action: () => {
        setDetailOpen(true);
      },
    },
  ];

  const openDetail = (data, e) => {
    setDetailOpen(true)
    setSelectedCommunity(data)
  }

  return (
    !isEmpty(targetPermission) && (
      <>
        <PageHeader title={"커뮤니티"} buttons={headerButtons} />
        <CardList
          fields={fields}
          isTable={false}
          list={list}
          isLoading={isLoading}
        />
        <DetailCommunity
          permission={targetPermission}
          employee={employee}
          selectedCommunity={selectedCommunity}
          setSelectedCommunity={setSelectedCommunity}
          open={detailOpen}
          setOpen={setDetailOpen}
          submit={filterSubmit}
        />
      </>
    ));
};

export default CommunityList;
